import { render, staticRenderFns } from "./qs2-18.vue?vue&type=template&id=005a80d6&scoped=true&"
import script from "./qs2-18.vue?vue&type=script&lang=js&"
export * from "./qs2-18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a80d6",
  null
  
)

export default component.exports